function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { enterpriseCardApi } from '@/api/enterprise';
import formBox from '../formBox.vue';
import Table from '../table.vue';
import myMixins from '../../mixins/method.js';
export default {
  created: function created() {
    this.getList();
  },
  mixins: [myMixins],
  data: function data() {
    return {
      tableData: [],
      pageLoading: false,
      notEmployees: '离职',
      fromTab: {},
      showText: '',
      total: 0,
      page: 1,
      limit: 15,
      selection: []
    };
  },
  methods: {
    // 筛选条件
    confirmData: function confirmData(from) {
      this.fromTab = _objectSpread({}, from);
      if (this.$refs.formBox.tableFrom.exportType === 1) {
        this.fromTab.limit = 0;
        this.fromTab.page = 0;
        this.fromTab.types = [1, 2, 3];
        this.getExportData(this.fromTab);
      } else {
        this.page = 1;
        this.getList(1);
        this.$refs.table.where.page = 1;
      }
    },
    // 分页
    limitFn: function limitFn(val) {
      this.limit = val;
      this.getList(1);
    },
    pageFn: function pageFn(page) {
      this.page = page;
      this.getList(1);
    },
    hanldeOptions: function hanldeOptions(data, type) {
      switch (type) {
        // 编辑
        case 'edit':
          {
            this.$emit('openDrawer', 'addDrawerIsShow', 'edit', data);
            break;
          }

        // 重新入职
        case 'reEntry':
          {
            this.$emit('openDrawer', 'addDrawerIsShow', 'edit', data, '重新入职');
            break;
          }

        // 删除
        case 'delete':
          {
            this.$emit('onDelete', data);
            break;
          }
      }
    },
    // 获取列表
    getList: function getList(val) {
      var _this = this;
      if (val == 1) {
        // this.page == val ? val : this.page
      } else {
        this.fromTab = {};
      }
      this.fromTab.limit = this.limit;
      this.fromTab.page = this.page;
      this.fromTab.types = [4];
      this.pageLoading = true;
      enterpriseCardApi(this.fromTab).then(function (res) {
        _this.pageLoading = false;
        _this.tableData = res.data.list;
        if (_this.tableData && _this.tableData.length > 0) {
          _this.tableData.map(function (value) {
            if (value.frames.length > 1) {
              value.frames.sort(function (a, b) {
                return b.is_mastart - a.is_mastart;
              }); //升序
            }
          });
        }
        _this.total = res.data.count;
      }).catch(function (err) {}).finally(function () {
        _this.pageLoading = false;
      });
    },
    // 展开
    showTextFn: function showTextFn(val) {
      this.showText = val;
    },
    // 多选表格
    multipleSelection: function multipleSelection(val) {
      this.selection = val;
    }
  },
  components: {
    formBox: formBox,
    Table: Table
  }
};